import React, { useEffect } from "react";
import {
  Typography,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useFetchOrgDataQuery } from "../../services/profileService";
import { styled } from "@mui/system";

const ViewOrg = () => {
  const { id: organization_id } = useParams();
  const navigate = useNavigate();
  console.log(organization_id);
  const {
    data: organization,
    isLoading,
    error,
    refetch: fetch_orgData,
  } = useFetchOrgDataQuery(organization_id);
  console.log(organization);
  const organizationMap=organization?.data
   useEffect(() => {
    
        fetch_orgData()
     
    }, [fetch_orgData]);
  if (isLoading) return <CircularProgress />;
  if (error)
    return (
      <Typography color="error">Error loading organization details.</Typography>
    );

  return (
    <>
      <SectionWrap component="section">
        <ContainerWrap>
          <RowWrap>
            <Col12Wrap sx={{ textAlign: "center", marginBottom: "20px" }}>
              <Typography
                sx={{
                  fontSize: "25px",
                  textAlign: "center",
                  fontWeight: "500",
                  margin: "0 10px",
                  color: "#2C2C2E",
                }}
              >
                Organization Details
              </Typography>
            </Col12Wrap>
            <Col12Wrap>
              <FormMiddleBoxWrap>
                <RowWrap>
                  <Col12Wrap>Organization Name: {organizationMap?.organization_name}</Col12Wrap>
                  <Col12Wrap>Owner Name: {organizationMap?.owner_name}</Col12Wrap>
                  <Col12Wrap>Owner Email: {organizationMap?.owner_email}</Col12Wrap>
                  <Col12Wrap>Owner Password: {organizationMap?.owner_password}</Col12Wrap>
                </RowWrap>
              </FormMiddleBoxWrap>
              <FormBtnBoxWrap>
                <RowWrap>
                  <Col12Wrap sx={{ textAlign: "center" }}>
                    <CustomBtn
                      variant="outlined"
                      onClick={() => navigate("/view-org")}
                    >
                      Back
                    </CustomBtn>
                  </Col12Wrap>
                </RowWrap>
              </FormBtnBoxWrap>
            </Col12Wrap>
          </RowWrap>
        </ContainerWrap>
      </SectionWrap>
    </>
  );
};

export default ViewOrg;

const SectionWrap = styled(Box)(() => ({
  padding: "30px 0",
}));
const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const FormMiddleBoxWrap = styled(Box)(() => ({
  padding: "50px 150px",
  background: "#ffffff",
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const FormBtnBoxWrap = styled(Box)(() => ({
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "30px",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
  },
}));
const CustomBtn = styled(Button)(() => ({
  width: "100%",
  fontSize: "20px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "10px",
  padding: "15px 15px",
  maxWidth: "250px",
  boxShadow: "none !important",
}));
